module.exports = __webpack_public_path__ + "img/DragonStorm_DG.fa236efe.png";